import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import { Container } from "react-bootstrap";
import GlobalColumnDefinations, { getHeader_FieldName } from "../../utility/grid/definitions/AgGridDefination";
import GridMaster from "../../utility/grid/GridMaster";
import Toaster from "../../utility/ui/notifications/Toaster";
import { getReqByType } from "../../../Services/trainingRequisition-service";
import ActioRenderTrainingReq from "../../utility/grid/renderers/ActionRenderers/ActioRenderTrainingReq";

export const TrainingReqInitiated = forwardRef((props, ref) => {
  const childRef = useRef();
  let formName = "TrainingRequisition";
  const [reload] = useState(false);
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [setAction] = useState("");
  const [setdata] = useState("");
  const [show1, setShow1] = useState(false);
  let userId = sessionStorage.getItem("User");

  const handleEdit = (row) => {
    props.setAction("Edit");
    props.setRowData(row);
    props.setShowForm(true);
    props.setCalledFrom("Initiated")
  };

  useImperativeHandle(ref, () => ({
    reload: async () => {
      fetchTrainingRequisition();
      setRefere();
      fetchColumnDefns();
    },
  }));

  useEffect(() => {
    fetchTrainingRequisition();
    setRefere();
    fetchColumnDefns();
  }, reload)

  const headerName = (field) => {
    let name = getHeader_FieldName(field, props.tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, props.tmpcolumnDefs, "getField");
    return name;
  };
  function setRefere() {
    props.setRefe(childRef)
  }
  const fetchTrainingRequisition = async () => {
    try {
      const tmpObj = { fieldValue: userId, flag: "initiated" };
      const result = await getReqByType(tmpObj);
      setFilteredResult(result || []);
    } catch (error) {
      console.error('Error fetching training requisitions:', error);
      setFilteredResult([]);
    }
  };
  const fetchColumnDefns = async () => {
    try {
      const result = GlobalColumnDefinations(props.tmpcolumnDefs);
      if (result && result.length >= 2) {
        result[result.length - 2].cellRenderer = actionRenderer;
      }
      setColumnDefs(result || []);
    } catch (error) {
      console.error('Error fetching column definitions:', error);
      setColumnDefs([]);
    }
  };

  const handleClose = () => {
    setShow1(false);
  };

  const actionRenderer = (params) => {
    return (
      <ActioRenderTrainingReq
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };

  return (
    <Container fluid>
      <ConfirmAlertModal
        formName={formName}
        show={show1}
        handleClose={handleClose}
      />
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}
        setExcelData={props.setExcelData}
        ref={childRef}
        paginationPageSize={7}
        pagination={true}
        height={450}
      />
      <Toaster />
    </Container>
  )
})